<template>
    <div>
        <div v-if="formData" class="clearfix MT10">
            <div v-if="siteUrl.get(formData.userType)"  class="fl site-url" >
                <div>小站链接:</div>
                <vue-qr class="MT20" :logoSrc="logo" :logoMargin="2" :text="siteWapUrl.get(formData.userType)" :size="180" :margin="0"></vue-qr>
                <div class="link-box MT10">
                    <el-link type="primary" icon="el-icon-monitor" :href="siteUrl.get(formData.userType)" target="_blank">WEB预览</el-link>
                    <el-link type="primary" icon="el-icon-mobile" :href="siteWapUrl.get(formData.userType)" target="_blank">WAP预览</el-link>
                </div>
            </div>
            <div v-if="formData.userType == 3" class="fl">
                <div>现场购票链接:</div>
                <vue-qr class="MT20" :logoSrc="logo" :logoMargin="2" :text="`${sswap}/pages/activity/livehouse/livehouse?siteId=${formData.id}`" :size="180" :margin="0"></vue-qr>
                <div class="link-box MT10">
                    <el-link type="primary" :href="`${sswap}/pages/activity/livehouse/livehouse?siteId=${formData.id}`" target="_blank">点击预览</el-link>
                </div>
            </div>
        </div>
        <el-divider></el-divider>   
        <el-form
            v-if="formData"
            :model="formData"
            :rules="rules"
            ref="formData"
            label-position="top"
        >    
            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="avatar" label="头像/Logo:">
                        <image-upload 
                            :url.sync="formData.avatar" 
                            :urlFull.sync="formData.avatar" 
                            :crop="true"
                            :width="800"
                            :height="800"
                            class="avatar"
                        >
                        </image-upload>
                    </el-form-item>
                </el-col>
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="name" label="名称:">
                        <el-input v-model="formData.name" placeholder="请输入名称" size="medium" maxlength="40"></el-input>
                    </el-form-item>
                    <el-form-item prop="city" label="所在城市:">
                        <el-cascader
                            v-model="formData.city"
                            :options="cityList"
                            filterable
                            :props="{label:'name',children:'cityList',value:'code',emitPath:false}"
                            size="medium"
                            style="width:100%">
                        </el-cascader>
                    </el-form-item>
                </el-col>
            </el-row>
            <!-- 艺人部分 -->
            <template v-if="formData.userType == 2">
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="type" label="艺人形式:">
                            <el-select v-model="formData.type" placeholder="请选择艺人形式" size="medium">
                                <el-option :value="1" label="个人"></el-option>
                                <el-option :value="2" label="团体"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="memberCount" label="成员人数:">
                        <el-input-number style="width:100%" v-model="formData.memberCount" :precision="0" controls-position="right" :min="1" :max="99999999" size="medium" placeholder="请输入成员人数"></el-input-number>
                    </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="styles" label="风格:">
                            <el-cascader
                                v-model="styles"
                                :options="styleList"
                                filterable
                                :props="{multiple:true,label:'name',children:'tags',value:'id',emitPath:true,checkStrictly:true}"
                                size="medium"
                                style="width:100%"
                                @change="selectStyles">
                                <template slot-scope="{ node, data }">
                                    <span>{{ data.name }}</span>
                                    <span v-if="!node.isLeaf"> ({{ data.tags.length }}) </span>
                                </template>
                            </el-cascader>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="mainStyleId" label="主要风格:">
                            <el-select v-model="formData.mainStyleId" placeholder="请选择主要风格" size="medium" clearable>
                                <el-option v-for="item in mainStyleList" :key="item.value" :label="item.name" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="birthday" label="组建年份:">
                            <el-date-picker v-model="formData.birthday" type="year" placeholder="选择年份"
                                value-format="timestamp" size="medium" :picker-options="pickerOptions"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>
            <!-- 场地部分 -->
            <template v-if="formData.userType == 3">
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="longitude" >
                            <span slot="label">
                                坐标地址:
                                <el-button type="text" icon="el-icon-map-location" @click="$refs.selectAddress.show()">选择地址</el-button> 
                                <small style="margin-left:10px" v-if="formData.longitude">(经度: {{formData.longitude}} 纬度: {{formData.latitude}})</small>
                            </span>
                            <el-input v-model="formData.address" placeholder="百度地图根据搜索结果返回的地址" size="medium" maxlength="100"></el-input>
                        </el-form-item> 
                    </el-col>  
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="contact" label="咨询电话:">
                            <el-input v-model="formData.contact" placeholder="请输入咨询电话号码" size="medium"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="capacity" label="容纳人数:">
                            <el-input v-model="formData.capacity" placeholder="请输入容纳人数" size="medium"  type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="freeTicketNum" label="赠票数量上限:">
                            <el-input v-model="formData.freeTicketNum" placeholder="请输入赠票数量上限" size="medium"  type="number"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="30">
                    <el-col :xs="24" :sm="12" :xl="8">
                        <el-form-item prop="siteType" label="场地类型:">
                        <!-- <el-cascader v-model="formData.siteType" :options="siteTypeList" :props="{value:'id',label:'name',children:'tags', emitPath:false}" placeholder="请选择场地类型" size="medium" style="width:100%"></el-cascader> -->
                        <el-select v-model="formData.siteType" placeholder="请选择场地类型" size="medium">
                            <el-option v-for="item in siteTypeList" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <!-- 厂牌部分 -->
            <template v-if="formData.userType == 5">
                <el-row :gutter="30">
                    <el-col :xs="24" :xl="16">
                        <el-form-item prop="performerIds" label="旗下艺人:">
                            <el-select 
                                v-model="formData.performerIds" 
                                filterable 
                                remote
                                multiple
                                placeholder="请选择艺人"
                                :remote-method="searchArtist"
                                :loading="userLoading"
                                size="medium">
                                <el-option
                                    v-for="a in artistList"
                                    :key="a.id"
                                    :label="a.name"
                                    :value="a.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
            </template>

            <el-row :gutter="30">
                <el-col :xs="24" :sm="12" :xl="8">
                    <el-form-item prop="poster" label="小站背景图:">
                        <image-upload 
                            :url.sync="formData.poster" 
                            :urlFull.sync="formData.poster" 
                            :crop="true"
                            :width="1000"
                            :height="920"
                            class="poster"
                        >
                        </image-upload>
                    </el-form-item>
                </el-col>
				<el-col :xs="24" :sm="12" :xl="8">
				    <el-form-item prop="qrCodeAddress" label="粉丝群二维码:">
				        <image-upload 
				            :url.sync="formData.qrCodeAddress" 
				            :urlFull.sync="formData.qrCodeAddress" 
				            :crop="true"
				            :width="440"
				            :height="440"
				            class="poster"
				        >
				        </image-upload>
				    </el-form-item>
				</el-col>
            </el-row>
            <el-row :gutter="30">
                <el-col :xs="24" :xl="16">
                    <el-form-item prop="desc" label="简介:">
                        <el-input v-model="formData.desc" type="textarea" :rows="4" maxlength="10000" show-word-limit></el-input>
                    </el-form-item>
                </el-col>
            </el-row>  
			 <el-row :gutter="30" v-if="formData.userType == 3">
			     <el-col :xs="24" :xl="16">
			         <el-form-item prop="auditRemark" label="场地特殊审核备注:">
			             <el-input v-model="formData.auditRemark" type="textarea" :rows="4" maxlength="200" show-word-limit></el-input>
			         </el-form-item>
			     </el-col>
			 </el-row>  

            <el-form-item>
                <el-button @click="goBack">返回</el-button>
                <el-button
                    type="primary"
                    @click="onSubmit"
                    :loading="btnLoading"
                    >保存</el-button
                >
            </el-form-item> 
        </el-form>


        <select-address 
            v-if="formData.userType == 3"
            ref="selectAddress" 
            :address.sync="formData.address" 
            :lng.sync="formData.longitude" 
            :lat.sync="formData.latitude">
        </select-address>
    </div>
</template>

<script>
import ImageUpload from '@/components/ImageUpload'
import {fetchAllTag,fetchAllCity,fetchUser} from '@/assets/js/commonApi'
import SelectAddress from '@/components/SelectAddressBaiduMap';
import VueQr from 'vue-qr'
import logo from '@/assets/img/logo.png';
import baseData from '@/assets/js/baseData';


const defaultData = {
    avatar:'',
    name:'',
    city:'',
    poster:'',
    desc:'',
    //艺人部分
    type:1,
    memberCount:1,
    birthday:'',
    styles:[],
    tags:[],
    mainStyleId: '',
    //场地部分
    latitude:'',
    longitude:'',
    address:'',
    contact:'',
    capacity:'',
    freeTicketNum:'',
    siteType: "",
	siteAuditRemark:'',
    //厂牌部分
    performerIds:[],
}
export default {
    props:{
        dataVo:{
            type:Object,
            default:null
        }
    },
    components:{ImageUpload,SelectAddress,VueQr},
    data(){
        return{
            formData:{
                ...defaultData,
            },
            rules:{
                name:[{required: true, message: '请输入名称'}],
                city:[{required: true, message: '请选择所在城市'}],
                memberCount:[{required: true, message: '请输入成员人数'}],
                styles:[{required: true, message: '请选择风格'}],
                longitude:[{required: true, message: '请通过百度地图选择坐标地址'}],
                capacity: [{ required: true, message: "请输入容纳人数" }],
                freeTicketNum:[{ required: true, message: "请输入赠票数量上限" }],
                siteType: [{ required: true, message: "请选择场地类型" }],
            },
            styles:[],
            styleList:[],//所有风格Tag集合
            mainStyleList: baseData.mainStyle,
            cityList:[],//所有省份城市集合
            redirect: this.$route.query.redirect,
            btnLoading:false,
            ssweb:process.env.VUE_APP_SSWEB_URL,
            sswap:process.env.VUE_APP_SSWAP_URL,
            id: this.$route.params.id,
            logo:logo,
            userLoading:false,
            artistList:[], //艺人集合
            pickerOptions:{
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            siteTypeList:[],
        }
    },
    computed:{
        submitAction(){
            return new Map([
                [2, '/performer/save'],
                [3, '/site/save'],
                [5, '/brand/save']
            ])
        },
        siteUrl(){
            return new Map([
                [2, this.ssweb+'/artist/'+this.id],
                [3, this.ssweb+'/venue/'+this.id],
                [5, this.ssweb+'/host/'+this.id]
            ])
        },
        siteWapUrl(){
            return new Map([
                [2, this.sswap+'/pages/site/artist/artist?id='+this.id],
                [3, this.sswap+'/pages/site/site/site?id='+this.id],
                [5, this.sswap+'/pages/site/brand/brand?id='+this.id]
            ])
        },
    },
    watch:{
        dataVo(v){
            this.styles = [];
            this.formData = v ?  {...defaultData,...v, city: parseInt(v.userCity) || 10, styles: [],tags:[],performerIds:[]} : {...defaultData,city:10, styles: [],tags:[],performerIds:[]};
            //艺人
            if( v.userType == 2 ){
                this.getStyleList();
                //风格id
                v.tagVOS.map(item => {
                    const _arry = [];
                    _arry.push(item.styleId);

                    this.formData.styles.push(item.styleId);
                    if(item.tagId){
                        this.formData.tags.push(item.tagId);
                        _arry.push(item.tagId);
                    }
                    
                    this.styles.push(_arry);
                })
                this.styles = Array.from(this.styles).sort((x,y) => x[0] - y[0]);
                this.formData.birthday = v.birthday ? new Date(v.birthday).getTime() : ''
            }
            //场地
            if( v.userType == 3 ){
                this.getSiteType();
            }
            //厂牌
            if( v.userType == 5 ){
                if(v.performers){
                    this.formData.performerIds = v.performers.map(item => item.id);
                    this.artistList = [...v.performers];
                }
            }
        }
    },
    mounted(){
        this.getCityList();
    },
    methods:{
        //获取所有风格
        async getStyleList(){
            const res = await fetchAllTag({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.styleList = result;
            }
        },
        //获取所有城市
        async getCityList(){
            const res = await fetchAllCity({}).catch(() => {});
            const{ state, result} = res.data;
            if( state == 1 ){
                this.cityList = result;
            }
        },
        //选取风格
        selectStyles(){
            // 风格&tag id组装
            let _styles = [], _tags = [];
            this.styles.forEach( item =>  {
                _styles.push( item[0] );
                if(item[1]){
                    _tags.push( item[1] ); 
                }
            })

            this.formData.styles = _styles ? [...new Set(_styles)] : [];
            this.formData.tags = _tags ? [...new Set(_tags)] : [];
        },
        //获取场地类型
        getSiteType(){
            this.$request({
                url: "/styleTag/showType/site/all",
                method: "post",
            }).then(res => {
                const { state, result } = res.data;
                if(state == 1){
                    this.siteTypeList = [...result]
                }
            }) 
        },
        //搜索艺人
        async searchArtist(query){
            if(query !== ""){
                this.userLoading = true;
                const res = await fetchUser({
                    queryValue:query,
                    userType:2,
                }).finally(() => {
                    this.userLoading = false;
                });
                
                const { state, result } = res.data;
                
                if (state == 1 && result) {
                    this.artistList = result;
                }
            }
        },
        //返回
        goBack() {
            if(this.redirect){
                this.$router.push({
                    path: this.redirect,
                });
            }else{
                this.$router.go(-1);
            }
        },
        //表单提交
        onSubmit() {
            this.$refs["formData"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;
                    this.$request({
                        url: this.submitAction.get(this.dataVo.userType),
                        method: "POST",
                        data: {...this.formData,userCity: this.formData.city},
                    })
                        .then((res) => {
                            //处理成功回调
                            const { state, msg } = res.data;
                            if (state && state == 1) {
                                
                                this.$confirm('是否返回列表', '操作成功', {
                                    type: 'success',
                                    center: true,
                                    confirmButtonText:'返回列表',
                                    cancelButtonText:'留在当前页面',
                                    closeOnClickModal: false
                                }).then(() => {
                                    this.goBack();
                                }).catch(() => {
                                   
                                })

                            } else {
                                return this.$message.error(msg || "操作失败");
                            }
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });
                }
            });
        },
    }
}
</script>

<style lang="scss" scoped>
.el-form{
    .avatar{
        ::v-deep .image{
            width: 160px;
            height: 160px;
        }
        ::v-deep .image-upload-content{
            height: 160px;
        }
        ::v-deep .el-image{
            border-radius: 100%;
            overflow: hidden;
            max-width: 80%;
            max-height: 80%;
        }
    }
    .poster{
        ::v-deep .image{
            width: 284px;
            // height: 160px;
        }
    }
}
.site-url{
    margin-right: 30px;
}
.link-box{
    text-align: center;
    .el-link{
        margin: 0 5px;
    }
}
</style>